<div class="d-flex flex-column h-100">
    <div class="flex-grow-1 overflow-auto">
        <div class="w-100 p-3">
            <div class="header mb-3">
                <div class="container-fluid">
                    <div class="row d-flex align-items-center solar-card">
                        <div class="col-auto px-0 text-center">
                            <span class="fa-stack">
                                <i class="fa fa-circle-thin fa-stack-2x"></i>
                                <i class="fa fa-info fa-stack-1x"></i>
                            </span>
                        </div>
                        <div class="col">
                            <p>
                                Pour estimer au mieux le potentiel solaire de votre toiture,
                                plusieurs questions vous seront posées au cours de cette simulation.
                            </p>
                            <p>
                                Tout d’abord, veuillez sélectionner ci-dessous votre profil pour
                                adapter le parcours de simulation de votre projet solaire et vous
                                proposer les aides spécifiques auxquelles vous pouvez prétendre.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="body">
                <div class="container-fluid solar-card bank-loan-container">
                    <h5 class="text-st-primary mb-3">Je sélectionne mon profil utilisateur</h5>

                    <form [formGroup]="profileFormGroup" class="profile-form">
                        <div class="radio-cards">
                            <label class="radio-card" *ngFor="let p of profiles">
                                <span class="label-text">{{ p.label }}</span>
                                <input type="radio" formControlName="profile" [value]="p.value" />
                            </label>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="footer border-top">
        <div class="container-fluid py-3">
            <div class="row">
                <div class="col-5">
                    <stButton
                        class="btn-st-lg"
                        btnClass="btn-st-default w-100 h-100"
                        btnLabel="Retour"
                        (onClick)="cancel()"
                    >
                    </stButton>
                </div>
                <div class="col-7">
                    <stButton
                        class="btn-st-lg"
                        btnClass="btn-st-primary w-100"
                        btnLabel="Valider mon profil"
                        [isDisabled]="!isFormValid"
                        (onClick)="validate()"
                    >
                    </stButton>
                </div>
            </div>
        </div>
    </div>
</div>
